






import Vue from 'vue'
import { Route } from 'vue-router'
import LoginContainer from '@/containers/Auth/Login'

export default Vue.extend({
  components: {
    LoginContainer
  },
  middleware: ['checkAuth'],
  computed: {
    redirectTo(): string | null {
      const redirectTo = this.$route.query['redirectTo']
      return typeof redirectTo !== 'string' ? null : redirectTo
    },
    email(): string | null {
      const email = this.$route.query['email']
      return typeof email === 'string' ? email : null
    },
    token(): string | null {
      const token = this.$route.query['token']
      return typeof token === 'string' ? token : null
    },
    forwardedParamsKeys(): string[] {
      const query = this.$route.query
      const defaultQueries = ['redirectTo', 'email', 'token']
      const targetKeys = Object.keys(query)
        .filter(key => !defaultQueries.includes(key))
        .filter(key => typeof query[key] === 'string')
      return targetKeys
    },
    forwardedParams(): Route['params'] {
      const query = this.$route.query
      return this.forwardedParamsKeys.reduce((acc, ac) => ((acc[ac] = query[ac] as string), acc), {} as Route['params'])
    },
    forwardedQueries(): Route['query'] {
      const query = this.$route.query
      const pageSpecificQueries = ['redirectTo']
      const forwardedParamsKeys = this.forwardedParamsKeys
      return Object.keys(query)
        .filter(key => !forwardedParamsKeys.includes(key) && !pageSpecificQueries.includes(key))
        .filter(key => !!query[key])
        .reduce((acc, ac) => ((acc[ac] = query[ac]), acc), {} as Route['query'])
    }
  }
})
